module.exports = __webpack_public_path__ + "img/headBack.86adadee.png";